import * as React from "react";
import { Redirect, RouteComponentProps, withRouter } from "react-router-dom";

import { ROUTES } from "@config/app.routing";

import { AUTH_REDIRECTS } from "@typings/globals";

import { useAuth } from "@hooks/useAuth";

interface Props extends RouteComponentProps {
  asAdminOnly?: boolean;
  children: React.ReactNode;
  redirect?: ROUTES;
}

const AuthGuard = withRouter((props: Props) => {
  const { search } = props.location;
  const { isUserStateKnown, isUserAdmin, isUserLoggedIn } = useAuth();
  const toObject = (pathname: string | ROUTES) => ({
    pathname,
    search,
    state: {
      referer: props.history.location.pathname,
      reason: AUTH_REDIRECTS.UNAUTHENTICATED,
      originalRoute: props.redirect ? props.location.pathname : undefined,
    },
  });

  if (!isUserStateKnown) {
    return null;
  }

  const isAuthenticated = Boolean(
    props.asAdminOnly ? isUserLoggedIn && isUserAdmin : isUserLoggedIn,
  );

  if (isAuthenticated) {
    return <React.Fragment>{props.children}</React.Fragment>;
  }

  if (props.redirect) {
    return <Redirect push={false} to={toObject(props.redirect)} />;
  }

  return <Redirect push={false} to={toObject(ROUTES.NOT_FOUND)} />;
});

AuthGuard.displayName = "AuthGuard";

export { AuthGuard };
